// extracted by mini-css-extract-plugin
module.exports = {"select":"InvoiceAdditionalFilters_select__hHpDb"};